import { type FC, useState } from 'react';
import { BsThreeDotsVertical } from 'react-icons/bs';
import ColumnOptionsDropdown from './ColumnOptionsDropdown';

interface Props {
	label: string;
	index: number;
	onAddColumnClick: (_) => void;
	onDeleteColumnClick: (_) => void;
}

const ColumnOptionsCell: FC<Props> = (props) => {
	const { label, index, onAddColumnClick, onDeleteColumnClick } = props;

	const [coords, setCoords] = useState({ top: 0, left: 0 });
	const [showDropdown, setShowDropdown] = useState(false);

	const handleColumnOptionsClick = (e) => {
		const rect = e.target.getBoundingClientRect();

		setCoords({ left: rect.x, top: rect.y + rect.height + window.scrollY });
		setShowDropdown(!showDropdown);
	};

	const onClickOutside = () => {
		setShowDropdown(false);
	};

	return (
		<div className="addColumn">
			<span>{label}</span>
			<BsThreeDotsVertical className="addButton" onClick={(e) => handleColumnOptionsClick(e)} />

			{showDropdown && (
				<ColumnOptionsDropdown
					coords={coords}
					label={label}
					index={index}
					onClickOutside={onClickOutside}
					onAddColumnClick={onAddColumnClick}
					onDeleteColumnClick={onDeleteColumnClick}
				/>
			)}
		</div>
	);
};

export default ColumnOptionsCell;
